import React, {useState} from "react";
import {Box, Button, Flex, Heading, Image, Input, SimpleGrid, Stack, Text} from "@chakra-ui/react";
import InfoBox from "../../../components/QueryinfoBox";
import { TicketState } from "../../../components/States";

export default function CardWithIllustration() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState({});
  const [error, setError] = useState("");
  const Handlequery = async () => {
    setLoading(true);
    setError(null);
    try {
      if (!password) {
        setError("Hata!! Takip numarası giriniz");
        setLoading(false);
        return;
      }
      const encodedPassword = encodeURIComponent(password);

      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}public/tickets/${encodedPassword}/`;
      const response = await fetch(apiUrl);
      if (response.ok) {
        const data = await response.json();
        setResponseData(data);
      } else if (response.status === 404) {
        setError("Girdiğiniz takip numarasına ait kayıt bulunamadı.");
        setLoading(false);
      } else {
        setError("Girdiğiniz takip numarasına ait kayıt bulunamadı.");
        setLoading(false);
      }
    } catch (error) {
    }
    setLoading(false)
  };
  const createdAt  = new Date(responseData.created_at);
  const formattedDate = createdAt.toLocaleDateString('tr-TR');
  return (
    <Flex
      minH={"100vh"}
      align={"center"}
      justify={"center"}
      py={12}
      bg={"gray.50"}
    >
      <Stack
        boxShadow={"2xl"}
        bg={"white"}
        rounded={"xl"}
        p={10}
        spacing={8}
        align={"center"}
      >
        <Image src={"https://inohom.b-cdn.net/newImages/inohomtrlogo.png"} w={64} h={24}/>
        <Stack align={"center"} spacing={2}>
          <Heading
            textTransform={"uppercase"}
            fontSize={"2xl"}
            style={{textAlign: "center"}}
            color={"gray.800"}
          >
           Servis Takip Ekranı
          </Heading>
          <Text
            mt={10}
            maxWidth={430}
            fontSize={"lg"}
            color={"gray.500"}
            style={{textAlign: "center"}}
          >
            Size SMS ile gönderilen sorgulama numarasını girerek destek durumunuzu görüntüleyebilirsiniz
          </Text>
          {error && (
            <Text as='b' fontSize='md' color="red.500" mt="2">
              {error}
            </Text>
          )}
        </Stack>
        <Stack
          spacing={4}
          direction={{base: "column", md: "row"}}
          w={"full"}
        >
          <Input
            onChange={(e) => setPassword(e.target.value)}
            type={"text"}
            placeholder={"sorgu numaranızı giriniz"}
            color={"gray.800"}
            bg={"gray.100"}
            rounded={"full"}
            border={0}
            _focus={{
              bg: "gray.200",
              outline: "none",
            }}
          />

          <Button
            isLoading={loading}
            onClick={Handlequery}
            bg={"blue.400"}
            rounded={"full"}
            color={"white"}
            flex={"1 0 auto"}
            _hover={{bg: "blue.500"}}
            _focus={{bg: "blue.500"}}
          >
            Sorgula
          </Button>
        </Stack>
        <Stack align={"center"} spacing={2}>
          {responseData && Object.keys(responseData).length > 0 && !error && (
            <>
              <Heading
                textTransform={"uppercase"}
                fontSize={"2xl"}
                style={{textAlign: "center"}}
                color={"red.600"}
              >
                {(responseData.number)}
              </Heading>
              <SimpleGrid columns={{base: 2, sm: 3, md: 3, lg: 4, xl: 4}} gap={5} mt={5} color='gray.400'>
                <InfoBox title="İsim:" value={(responseData.full_name)}/>
                <InfoBox title="Adres:" value={(responseData.address)}/>
                <Box>
                  <Text whiteSpace='nowrap' fontWeight="500">Durumu</Text>
                  <Text fontWeight="400" fontSize="sm"><TicketState state={responseData.state}/></Text>
                </Box>
                <InfoBox title="Oluşturulma tarihi:" value={formattedDate}/>
                <InfoBox title="İlgili bayi iletişim numarası:" value={responseData.phone_number}/>
              </SimpleGrid>
            </>
          )}
        </Stack>
      </Stack>
    </Flex>
  )

}
